import { RESET_STATE } from '../../../redux/actions';
import { userActionsTypes } from './userActionTypes';

const { ACCESS_LIST, TIME_INTERVALS, ALERTS_COUNT } = userActionsTypes;

const intialState = {
	accesslist: {},
	timeTnterval: {
		alert_time_interval: '120000',
		dashboard_time_interval: '300000',
		notification_time_interval: '60000',
		sequence_time_interval: '300000',
	},
	alertCount: '',
};

export const userReducers = (state = intialState, { type, payload }) => {
	switch (type) {
		case ACCESS_LIST:
			return { ...state, accesslist: payload };
		case TIME_INTERVALS:
			return { ...state, timeTnterval: payload };
		case ALERTS_COUNT:
			return { ...state, alertCount: payload };
		case RESET_STATE:
			return intialState;
		default:
			return state;
	}
};
